import firebase from 'firebase/app'
import Config from '@/config'

export function initFirebase() {
  firebase.initializeApp(Config.firebase)
}
